import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Menu } from "primereact/menu";
import { confirmDialog } from "primereact/confirmdialog";
import { InputComponent } from "../InputComponent";
import { TablaDinamica } from "../TablaDinamica";
import * as generic from "../Generico";
import { useLazyParams } from "../../hooks/useLazyParams";
import { Laboral } from "../../models/trust/empleado/Laboral";
import { DatoLaboralService } from "../../service/trust/empleado/DatoLaboralService";
import { CatalogoService } from "../../service/CatalogoService";

export const InformacionLaboral = ({ toast, id, catalogos, permss, soloLectura }) => {

    const omodel = new Laboral();
    const defaultValues = generic.funDefault(omodel.model, null);

    const [dialogVisible, setDialogVisible] = useState(false);
    const [registroSeleccionado, setRegistroSeleccionado] = useState(null);
    const [ecuador, setEcuador] = useState(false);
    const [ciudades, setCiudades] = useState([]);
    const menuRef = useRef(null);

    const datoLaboralSrv = new DatoLaboralService();
    const catalogoService = new CatalogoService();
    const tablaLaboral = useLazyParams({ modelo: omodel.model });

    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue, watch } = useForm({ defaultValues });
    const { inText, inDrop, inCalendar } = InputComponent({ omodel, errors, control, permss, id: getValues('id'), soloLectura });

    const fechaInicioWatcher = watch('fecha_inicio');
    const fechaFinWatcher = watch('fecha_fin');

    useEffect(() => {
        if (id) loadLazyData();
        // eslint-disable-next-line
    }, [tablaLaboral.lazyParams, id]);

    const loadLazyData = () => {
        tablaLaboral.setLoading(true);
        const _params = { ...tablaLaboral.lazyParams, idp: id };
        datoLaboralSrv.getLista({ lazyEvent: JSON.stringify(_params) }).then(res => {
            tablaLaboral.setTotalRecords(res.data.total);
            tablaLaboral.setData(res.data.registros);
        }).finally(() => tablaLaboral.setLoading(false));
    };

    const openNew = () => {
        reset(defaultValues);
        setEcuador(false);
        setCiudades([]);
        setDialogVisible(true);
    };

    const hideDialog = () => setDialogVisible(false);

    const onSubmit = (data) => {
        data.idp = id;
        data.fecha_inicio = generic.dateToString(data.fecha_inicio);
        data.fecha_fin = generic.dateToString(data.fecha_fin);
        data.ec = catalogos?.ecuador;

        const request = getValues('id') == null
            ? datoLaboralSrv.nuevo(data)
            : datoLaboralSrv.editar(data);

        request.then(res => {
            setDialogVisible(false);
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => generic.funcErrorHibrida(error, toast, setError));
    };

    const editRegistro = (idReg) => {
        datoLaboralSrv.consultar(idReg).then(res => {
            const _data = res.data.dato_laboral;
            setEcuador(_data.pais?.cat_id === catalogos?.ecuador?.cat_id);
            if (res.data.ciudades) setCiudades(res.data.ciudades);
            _data.fecha_inicio = generic.stringToDate(_data.fecha_inicio);
            _data.fecha_fin = generic.stringToDate(_data.fecha_fin);
            reset(generic.renewValues(_data, omodel.model));
            setDialogVisible(true);
        });
    };

    const confirmDelete = (idReg) => {
        confirmDialog({
            message: '¿Está seguro de eliminar este dato laboral?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                datoLaboralSrv.eliminar(idReg).then(res => {
                    loadLazyData();
                    generic.funcSuccess(res, toast);
                }).catch(error => generic.funcDeleteError(error, toast));
            }
        });
    };

    const onChangePais = (e) => {
        setEcuador(e.value?.cat_id === catalogos?.ecuador?.cat_id);
        setValue('provincia', null);
        setValue('ciudad', null);
        setValue('canton', '');
        setCiudades([]);
    };

    const onChangeProvincia = (e) => {
        setValue('ciudad', null);
        if (!e?.value) { setCiudades([]); return; }
        catalogoService.getCatalogosId(e.value.cat_id).then(res => setCiudades(res.data));
    };

    const itemsMenu = () => {
        if (soloLectura) {
            return [{
                label: 'Opciones',
                items: [{ label: 'Ver detalle', icon: 'pi pi-eye', command: () => editRegistro(registroSeleccionado?.id) }]
            }];
        }
        return [{
            label: 'Opciones',
            items: [
                { label: 'Editar', icon: 'pi pi-pencil', command: () => editRegistro(registroSeleccionado?.id) },
                { label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete(registroSeleccionado?.id) }
            ]
        }];
    };

    const accionesTemplate = (rowData) => (
        <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu_laboral" aria-haspopup onClick={(e) => { setRegistroSeleccionado(rowData); menuRef.current.toggle(e); }} />
    );

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '4rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const cabeceraTabla = () => (
        <div className="flex align-items-center justify-content-start gap-3 py-1">
            {permss?.crear && id && !soloLectura && (
                <Button icon="pi pi-plus" className="p-button-success p-button-sm" type="button" onClick={openNew} />
            )}
            <span className="text-sm font-semibold text-600 uppercase tracking-wider">
                Listado de Datos Laborales
            </span>
        </div>
    );

    return (
        <div className="componente-informacion-laboral">
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu_laboral" />
            <TablaDinamica modelo={omodel.model} estadoTabla={tablaLaboral} datos={tablaLaboral.data} totalRegistros={tablaLaboral.totalRecords} dataKey="id" acciones={ColumnaAcciones} header={cabeceraTabla()} />

            <Dialog visible={dialogVisible} header={getValues('id') == null ? "Nuevo Dato Laboral" : "Editar Dato Laboral"} modal className="p-fluid modal-ssize dialog-personalizado" onHide={hideDialog} style={{ width: '680px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid px-2">
                        <div className="col-12 mb-3">
                            <div className="flex align-items-center">
                                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                    <i className="pi pi-briefcase text-primary"></i>
                                    INFORMACIÓN LABORAL
                                </span>
                                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                            </div>
                        </div>

                        {inText('institucion', { icon: 'pi pi-building' }, 12)}
                        {inText('cargo', { icon: 'pi pi-id-card' }, 6)}
                        {inCalendar('fecha_inicio', { maxDate: fechaFinWatcher ? new Date(fechaFinWatcher) : new Date() }, 3)}
                        {inCalendar('fecha_fin', { minDate: fechaInicioWatcher ? new Date(fechaInicioWatcher) : null, maxDate: new Date() }, 3)}
                        {inDrop('pais', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePais }, 4)}
                        {ecuador ? (
                            <>
                                {inDrop('provincia', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvincia }, 4)}
                                {inDrop('ciudad', ciudades, { lab: omodel.optionLabel }, 4)}
                            </>
                        ) : (
                            inText('canton', { icon: 'pi pi-map-marker' }, 8)
                        )}

                        <div className="col-12 mt-4 pt-3 flex justify-content-end border-top-1 border-300">
                            {soloLectura ? (
                                <div className="field col-auto p-0 m-0">
                                    <Button label="Cerrar" style={{ width: '120px' }} icon="pi pi-times" type="button" className="p-button-warning" onClick={hideDialog} />
                                </div>
                            ) : (
                                generic.buttonsForms(hideDialog)
                            )}
                        </div>

                    </div>
                </form>
            </Dialog>
        </div>
    );
};
